import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, unref as _unref } from "vue"

const _hoisted_1 = { class: "cmd00300-upload-form" }
const _hoisted_2 = { class: "row q-gutter-x-xs items-center" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "cmd00300-file-table q-mb-md" }
const _hoisted_5 = { class: "full-width row q-gutter-sm" }
const _hoisted_6 = { class: "q-pt-xs" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "cmd00300-imported-table" }
const _hoisted_9 = { class: "full-width row q-gutter-sm" }
const _hoisted_10 = { class: "q-pt-xs" }
const _hoisted_11 = { class: "add-btn-area flex items-center filter-select justify-between" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = {
  key: 1,
  style: {"height":"36px"}
}
const _hoisted_14 = ["href"]

import { ref } from 'vue';
import Loading from 'quasar/src/plugins/Loading.js';;
import { useRouter } from 'vue-router';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import axios from '../../common/axios-common';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import commaFormat from '../../common/utils/numberUtils';
import * as FileStatus from '../../common/code/StockPriceStatusCode';
import MessageChip from '../../components/chip/MessageChip.vue';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import { isFilesExist } from '../../common/utils/fileUtils';

// アップロードCSV一覧
interface UploadCsvList {
  file_name: string;
  file_size: string;
  update_date: string;
}

// 取込済み在庫価格ファイル一覧
interface ImportedFileList {
  stock_price_file_id: number;
  stock_price_file_name: string;
  supplier_name: string;
  sup_category: string;
  status: string;
  exec_date_str: string;
  import_start_time_str: string;
  import_end_time_str: string;
  import_num: string;
  memo: string;
  err_file_name: string;
}

// カラム表示機能
interface VisibleColumn {
  name: string;
  label: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00300',
  setup(__props) {

const router = useRouter();

// 表示カラム
const visibleColumns = ref<Array<string>>([]);
// カラム表示設定の選択肢
const visibleColumnOptions = ref<Array<VisibleColumn>>([]);

// エラーメッセージ
const errMessage = ref('');
// MessageChip表示フラグ
const isMessageChip = ref(false);
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

// Dialogタイトル
const dialogTitle = ref('');
// Dialog表示レベル
const dialogLevel = ref('');
// Dialog本文
const dialogText = ref(['']);
// 確認Dialogフラグ
const isConfFlg = ref(false);

// アップロードDialog表示フラグ
const isUploadDisplay = ref(false);
// アップロード削除Dialog表示フラグ
const isUploadDeleteDisplayFlg = ref(false);
// 中止Dialog表示フラグ
const isStopImportDisplay = ref(false);

// 在庫・価格ファイルID
const stockPriceFileId = ref('');
// CSVファイル名
const csvFileName = ref('');
// アップロードファイル
const uploadFiles = ref<File[]>([]);
// アップロードファイルチェックフラグ
const uploadCheck = ref(0);

// アップロードSDFile一覧カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fileColumns: Array<any> = [
  {
    name: 'editDelete',
    field: (row: UploadCsvList) => row.file_name,
    required: true,
  },
  {
    name: ' file_name',
    label: '在庫価格ファイル名',
    align: 'left',
    field: (row: UploadCsvList) => row.file_name,
    sortable: true,
  },
  {
    name: 'file_size',
    label: 'ファイルサイズ',
    align: 'left',
    field: (row: UploadCsvList) => row.file_size,
    classes: 'text-right',
    style: 'width: 160px',
    sortable: true,
  },
  {
    name: 'update_date',
    label: '更新日時',
    align: 'left',
    field: (row: UploadCsvList) => row.update_date,
    style: 'width: 160px',
    sortable: true,
  },
];

// 取込済み在庫価格ファイル一覧カラム
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const importedColumns: Array<any> = [
  {
    name: 'stop',
    align: 'center',
    field: 'stop',
    style: 'width: 140px',
    required: true,
  },
  {
    name: 'stock_price_file_name',
    label: '在庫価格ファイル名',
    align: 'left',
    field: (row: ImportedFileList) => row.stock_price_file_name,
    sortable: true,
  },
  {
    name: 'supplier_name',
    label: 'サプライヤ名',
    align: 'left',
    field: (row: ImportedFileList) => row.supplier_name,
    sortable: true,
  },
  {
    name: 'sup_category',
    label: 'カテゴリー',
    align: 'left',
    field: (row: ImportedFileList) => row.sup_category,
    sortable: true,
  },
  {
    name: 'status',
    label: 'ステータス',
    align: 'left',
    field: (row: ImportedFileList) => row.status,
    sortable: true,
  },
  {
    name: 'exec_date_str',
    label: '取込予定日時',
    align: 'left',
    field: (row: ImportedFileList) => row.exec_date_str,
    style: 'width: 140px',
    sortable: true,
  },
  {
    name: 'import_start_time_str',
    label: '取込開始日時',
    align: 'left',
    field: (row: ImportedFileList) => row.import_start_time_str,
    style: 'width: 140px',
    sortable: true,
  },
  {
    name: 'import_end_time_str',
    label: '取込完了日時',
    align: 'left',
    field: (row: ImportedFileList) => row.import_end_time_str,
    style: 'width: 140px',
    sortable: true,
  },
  {
    name: 'import_num',
    label: '取込品目数',
    align: 'left',
    field: (row: ImportedFileList) => row.import_num,
    classes: 'text-right',
    sortable: true,
  },
  {
    name: 'memo',
    label: '備考',
    align: 'left',
    field: (row: ImportedFileList) => row.memo,
    sortable: true,
  },
  {
    name: 'download',
    label: 'エラーファイル',
    field: (row: ImportedFileList) => row.err_file_name,
  },
];

// アップロードSDFile一覧データ
const fileData = ref<UploadCsvList[]>([]);

// 取込済み在庫価格ファイル一覧データ
const importedFileData = ref<ImportedFileList[]>([]);

/**
 * 完了ステータスでエラーファイルが存在するか判定
 * @param {string} status ファイルステータス
 * @param {string} errFile エラーファイル
 * @returns 条件に該当する場合true
 */
const isCompErrExist = (status: string, errFile: string) => {
  // Statusが完了かつエラーファイルが存在する場合
  if (status === FileStatus.default.COMPLETED && errFile) {
    return true;
  }
  return false;
};

/**
 * エラーのステータスであることを判定
 * @param {string} status ファイルステータス
 * @param {string} errFile エラーファイル
 * @returns 条件に該当する場合true
 */
const isErrStatusExist = (status: string) => {
  if (
    // ファイルステータスがシステムエラーまたはファイルフォーマットエラーの場合
    status === FileStatus.default.SYSTEM_ERROR ||
    status === FileStatus.default.FILE_FORMAT_ERROR
  ) {
    return true;
  }
  return false;
};

/**
 * アップロード確認ダイアログ表示
 */
const displayUploadDialog = () => {
  dialogTitle.value = 'アップロード確認';
  dialogLevel.value = 'information';
  dialogText.value = ['選択したファイルをアップロードします。', 'よろしいですか？'];
  isConfFlg.value = false;
  isUploadDisplay.value = true;
};

/**
 * アップロード完了ダイアログ
 */
const completeUploadDialog = () => {
  dialogTitle.value = 'アップロード完了';
  dialogLevel.value = 'information';
  dialogText.value = ['ファイルのアップロードが完了しました。'];
  isConfFlg.value = true;
  isUploadDisplay.value = true;
};

/**
 * 取込中止確認ダイアログ表示
 * @param {string} fileName CSVファイル名
 * @param {string} fileId 在庫・価格ファイルID
 */
const displayStopImportDialog = (fileName: string, fileId: string) => {
  stockPriceFileId.value = fileId;
  dialogTitle.value = '取込中止確認';
  dialogLevel.value = 'information';
  dialogText.value = [`${fileName}の取込処理を中止します。`, 'よろしいですか？'];
  isConfFlg.value = false;
  isStopImportDisplay.value = true;
};

/**
 * 取込中止受付完了ダイアログ
 */
const completeStopImportDialog = () => {
  dialogTitle.value = '受付完了';
  dialogLevel.value = 'information';
  dialogText.value = ['取込中止要求を受け付けました。'];
  isConfFlg.value = true;
  isStopImportDisplay.value = true;
};

/**
 * 取込中止失敗ダイアログ
 */
const failStopImportDialog = () => {
  dialogTitle.value = '取込中止エラー';
  dialogLevel.value = 'error';
  dialogText.value = [
    'ステータスが変更されたため、取込処理を中止できませんでした。',
    'データを再度確認してください。',
  ];
  isConfFlg.value = true;
  isStopImportDisplay.value = true;
};

/**
 * アップロード削除確認ダイアログ表示
 * @param {string} fileName ファイル名
 */
const displayDeleteUploadDialog = (fileName: string) => {
  csvFileName.value = fileName;
  dialogTitle.value = '削除確認';
  dialogLevel.value = 'information';
  dialogText.value = [`${fileName}を削除します。`, 'よろしいですか？'];
  isConfFlg.value = false;
  isUploadDeleteDisplayFlg.value = true;
};

/**
 * 削除完了ダイアログ
 */
const completeDeleteDialog = () => {
  dialogTitle.value = '削除完了';
  dialogLevel.value = 'information';
  dialogText.value = ['削除が完了しました。'];
  isConfFlg.value = true;
};

/**
 * 初期表示データ取得
 */
const getInitData = () => {
  // Loading Start
  Loading.show();

  axios
    .post('/cmd003001/init')
    .then((res) => {
      const { common, uploadCsvList, importedCsvList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          fileData.value = uploadCsvList;
          importedFileData.value = importedCsvList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

/**
 * ファイルアップロード
 */
const uploadFile = async () => {
  isUploadDisplay.value = false;
  // エラー初期化
  errMessage.value = '';
  isMessageChip.value = false;

  // Loading Start
  Loading.show();

  const formData = new FormData();
  Object.entries(uploadFiles.value).forEach(([, value]) => {
    formData.append('fileList', value);
  });

  axios
    .post('/cmd003001/csv-upload', formData)
    .then((res) => {
      const { common, uploadCsvList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          fileData.value = uploadCsvList;
          uploadFiles.value = [];
          completeUploadDialog();
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * ファイルアップロードチェック
 */
const checkUploadFile = async () => {
  isFilesExist(uploadFiles.value).then((value) => {
    if (value) {
      uploadFile();
    } else {
      uploadCheck.value = 0;
      Promise.all(
        Object.entries(uploadFiles.value).map(async (item) => {
          if (item[1].size === 0) {
            uploadCheck.value += 1;
          }
        })
      );
      dialogTitle.value = 'ファイル読み込みエラー';
      dialogLevel.value = 'error';
      if (uploadCheck.value !== 0) {
        dialogText.value = [
          '選択したファイルは内容が設定されていません。',
          'ファイルを再度選択してください。',
        ];
      } else {
        dialogText.value = [
          '更新または削除されたファイルがあるため、アップロードできませんでした。',
          'ファイルを再度選択してください。',
        ];
      }
      isConfFlg.value = true;
      isUploadDisplay.value = true;
    }
  });
};

/**
 * アップロードファイル削除
 */
const deleteUploadFile = () => {
  isUploadDeleteDisplayFlg.value = false;
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('file_name', csvFileName.value);

  axios
    .post('/cmd003001/delete-upload-file', formData)
    .then((res) => {
      const { common, uploadCsvList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          fileData.value = uploadCsvList;
          completeDeleteDialog();
          isUploadDeleteDisplayFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // ファイルが存在しない場合
            case DetailResultStatusCode.FILE_NOT_EXIST_ERROR:
              fileData.value = uploadCsvList;
              dialogTitle.value = 'ファイル削除エラー';
              dialogLevel.value = 'error';
              dialogText.value = [common.message];
              isConfFlg.value = true;
              isUploadDeleteDisplayFlg.value = true;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 取込中止
 */
const stopImport = () => {
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('stock_price_file_id', stockPriceFileId.value);

  axios
    .post('/cmd003001/stop-import', formData)
    .then((res) => {
      const { common, importedCsvList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          importedFileData.value = importedCsvList;
          // ダイアログ表示
          completeStopImportDialog();
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            // ファイルステータスがすでに中止されている場合
            case DetailResultStatusCode.SELECT_DATA_MISMATCH:
              importedFileData.value = importedCsvList;
              // ダイアログ表示
              failStopImportDialog();
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;

            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * ログ再読み込み
 */
const reloadLog = () => {
  // Loading Start
  Loading.show();

  axios
    .post('/cmd003001/reload-log')
    .then((res) => {
      const { common, importedCsvList } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          importedFileData.value = importedCsvList;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 在庫価格ファイル取込フォーマット指定画面に遷移
 * @param {string} fileName ファイル名
 */
const editCsvFormat = (fileName: string) => {
  router.push({ name: 'stockPriceSetFormat', params: { fileName } });
};

/**
 * 初期表示処理
 */
getInitData();
// 取込済み在庫価格ファイル一覧のカラム表示設定
for (let i = 0; i < importedColumns.length; i += 1) {
  visibleColumns.value.push(importedColumns[i].name);
  if (importedColumns[i].name !== 'stop') {
    visibleColumnOptions.value.push({
      name: importedColumns[i].name,
      label: importedColumns[i].label,
    });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_chip = _resolveComponent("q-chip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[9] || (_cache[9] = [
        _createTextVNode("在庫価格ファイル取込(CSV)")
      ])),
      _: 1
    }),
    _createVNode(MessageChip, {
      display: isMessageChip.value,
      level: "E",
      message: errMessage.value
    }, null, 8, ["display", "message"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[11] || (_cache[11] = _createElementVNode("label", {
        class: "text-weight-bold",
        style: {"font-size":"1.1rem"}
      }, "在庫価格ファイルアップロード", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_q_file, {
            modelValue: uploadFiles.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((uploadFiles).value = $event)),
            outlined: "",
            multiple: "",
            append: "",
            dense: "",
            clearable: "",
            "use-chips": "",
            accept: ".csv",
            onClear: _cache[1] || (_cache[1] = ($event: any) => (uploadFiles.value = []))
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "attach_file" })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_q_btn, {
            color: "primary",
            label: "アップロード",
            icon: "mdi-upload",
            disable: uploadFiles.value.length ? false : true,
            class: _normalizeClass(uploadFiles.value.length ? '' : 'cmd00300-disabled-btn'),
            style: {"height":"40px"},
            onClick: displayUploadDialog
          }, null, 8, ["disable", "class"]),
          (uploadFiles.value.length ? false : true)
            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                key: 0,
                anchor: "top middle",
                self: "bottom middle",
                offset: [15, 15]
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("strong", null, "アップロードするファイルを選択してください", -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[12] || (_cache[12] = _createElementVNode("label", {
        class: "text-weight-bold",
        style: {"font-size":"1.1rem"}
      }, " アップロード在庫価格ファイル一覧 ", -1)),
      _createElementVNode("div", {
        class: _normalizeClass('chem-table-area btn-exist ' + (fileData.value.length === 0 ? 'table-nodata' : ''))
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: fileData.value,
          columns: fileColumns,
          "row-key": "index",
          flat: "",
          dense: "",
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_6, _toDisplayString(message), 1)
            ])
          ]),
          "header-cell-editDelete": _withCtx(() => [
            _createVNode(_component_q_th, { class: "table-btn-area delete-btn-exists" })
          ]),
          "body-cell-editDelete": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  class: "table-btn-area delete-btn-exists"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_q_btn, {
                        icon: "mdi-pencil",
                        label: "編集",
                        color: "primary",
                        onClick: ($event: any) => (editCsvFormat(cell.row.file_name))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_q_btn, {
                        icon: "mdi-close",
                        label: "削除",
                        class: "deletebtn",
                        outline: "",
                        color: "primary",
                        style: {"color":"var(--q-delete)"},
                        onClick: ($event: any) => (displayDeleteUploadDialog(cell.row.file_name))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          "body-cell": _withCtx((cell) => [
            (!hideNoDataFlg.value)
              ? (_openBlock(), _createBlock(_component_q_td, {
                  key: 0,
                  props: cell
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(cell.value), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["rows", "hide-no-data", "pagination-label"])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "row q-mb-sm" }, [
        _createElementVNode("div", { class: "col" }, [
          _createElementVNode("label", {
            class: "text-weight-bold",
            style: {"font-size":"1.1rem"}
          }, " 取込済み在庫価格ファイル一覧 ")
        ])
      ], -1)),
      _createElementVNode("div", {
        class: _normalizeClass(
          'chem-table-area btn-exist table-top-button nofixed-column ' +
          (importedFileData.value.length === 0 ? 'table-nodata' : '')
        )
      }, [
        _createVNode(_component_q_table, {
          class: "my-sticky-header-column-table",
          rows: importedFileData.value,
          columns: importedColumns,
          "row-key": "index",
          flat: "",
          dense: "",
          "visible-columns": visibleColumns.value,
          options: visibleColumnOptions.value,
          separator: "cell",
          "hide-no-data": hideNoDataFlg.value,
          "no-data-label": "データがありません。",
          "rows-per-page-options": [10, 20, 50, 0],
          "rows-per-page-label": "件表示",
          "pagination-label": 
            (firstRowIndex, endRowIndex, totalRowsNumber) => {
              return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
            }
          
        }, {
          "no-data": _withCtx(({ message }) => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_q_icon, {
                size: "24px",
                name: "mdi-alert-circle-outline"
              }),
              _createElementVNode("span", _hoisted_10, _toDisplayString(message), 1)
            ])
          ]),
          top: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_q_select, {
                modelValue: visibleColumns.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visibleColumns).value = $event)),
                multiple: "",
                outlined: "",
                dense: "",
                "options-dense": "",
                "display-value": "カラム表示設定",
                "emit-value": "",
                "map-options": "",
                options: visibleColumnOptions.value,
                "option-value": "name",
                color: "primary",
                class: "column-disp"
              }, null, 8, ["modelValue", "options"]),
              _createVNode(_component_q_btn, {
                color: "primary",
                outline: "",
                label: "更新",
                style: {"width":"100px"},
                icon: "mdi-autorenew",
                onClick: reloadLog
              })
            ])
          ]),
          "header-cell-stop": _withCtx((val) => [
            _createVNode(_component_q_th, { class: "table-btn-area stopbtn-area" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(val.col.label), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          "header-cell-download": _withCtx((val) => [
            _createVNode(_component_q_th, { class: "table-btn-area right-table-btn" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(val.col.label), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell-stop": _withCtx((cell) => [
            _createVNode(_component_q_td, { class: "table-btn-area stopbtn-area" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  (cell.row.status === FileStatus.default.BUSY)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        style: {"width":"50px","background-color":"var(--q-brightRed)","color":"var(--q-pureWhite)","letter-spacing":"4px","padding-left":"14px"},
                        label: "中止",
                        onClick: ($event: any) => (
                    displayStopImportDialog(
                      cell.row.stock_price_file_name,
                      cell.row.stock_price_file_id
                    )
                  )
                      }, null, 8, ["onClick"]))
                    : (_openBlock(), _createElementBlock("label", _hoisted_13))
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell-download": _withCtx((cell) => [
            _createVNode(_component_q_td, null, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  style: {"text-decoration":"none","color":"red"},
                  href: `/cmd003001/download-err-csv?fileId=${cell.row.stock_price_file_id}`
                }, [
                  (cell.row.err_file_name)
                    ? (_openBlock(), _createBlock(_component_q_chip, {
                        key: 0,
                        clickable: "",
                        outline: "",
                        square: "",
                        color: "red",
                        "text-color": "black",
                        icon: "mdi-download"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(cell.row.err_file_name), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_14)
              ]),
              _: 2
            }, 1024)
          ]),
          "body-cell-status": _withCtx((props) => [
            _createVNode(_component_q_td, {
              props: props,
              style: _normalizeStyle(isErrStatusExist(props.row.status) ? 'color: red' : '')
            }, {
              default: _withCtx(() => [
                (isCompErrExist(props.row.status, props.row.err_file_name))
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      size: "20px",
                      name: "mdi-alert",
                      style: {"color":"var(--q-informationPublish)"}
                    }))
                  : (isErrStatusExist(props.row.status))
                    ? (_openBlock(), _createBlock(_component_q_icon, {
                        key: 1,
                        size: "20px",
                        name: "mdi-close-circle"
                      }))
                    : (props.row.status === FileStatus.default.ABORT)
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 2,
                          size: "20px",
                          name: "mdi-cancel"
                        }))
                      : (props.row.status === FileStatus.default.COMPLETED)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 3,
                            size: "20px",
                            name: "mdi-check-circle",
                            style: {"color":"green"}
                          }))
                        : (props.row.status === FileStatus.default.CSV_BEING_IMPORTED)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 4,
                              size: "20px",
                              name: "mdi-progress-check"
                            }))
                          : (_openBlock(), _createBlock(_component_q_icon, {
                              key: 5,
                              size: "20px",
                              name: "mdi-calendar-check"
                            })),
                _createTextVNode(" " + _toDisplayString(isCompErrExist(props.row.status, props.row.err_file_name)
                  ? '完了(エラー有り)'
                  : FileStatus.getName(props.row.status)), 1)
              ]),
              _: 2
            }, 1032, ["props", "style"])
          ]),
          "body-cell-import_num": _withCtx((props) => [
            _createVNode(_component_q_td, { props: props }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.import_num ? _unref(commaFormat)(props.row.import_num) : props.row.import_num), 1)
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 1
        }, 8, ["rows", "visible-columns", "options", "hide-no-data", "pagination-label"])
      ], 2)
    ]),
    _createVNode(AlertDialog, {
      display: isUploadDisplay.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[3] || (_cache[3] = ($event: any) => (isUploadDisplay.value = false)),
      onConfirm: checkUploadFile,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (isUploadDisplay.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isUploadDeleteDisplayFlg.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[5] || (_cache[5] = ($event: any) => (isUploadDeleteDisplayFlg.value = false)),
      onConfirm: deleteUploadFile,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (isUploadDeleteDisplayFlg.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"]),
    _createVNode(AlertDialog, {
      display: isStopImportDisplay.value,
      level: dialogLevel.value,
      confirmation: isConfFlg.value,
      title: dialogTitle.value,
      text: dialogText.value,
      onComplete: _cache[7] || (_cache[7] = ($event: any) => (isStopImportDisplay.value = false)),
      onConfirm: stopImport,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (isStopImportDisplay.value = false))
    }, null, 8, ["display", "level", "confirmation", "title", "text"])
  ]))
}
}

})